<template>
  <div>
    <section class="block-masthead border-bottom">
      <navigation theme="dark" favourite-theme="dark"/>
      <div class="row no-gutters">
        <div class="block col-md-12 d-flex align-items-center bg-green">
          <div class="content" data-aos="fade-up">
            <h1>Oops! That page can’t be found.</h1>
            <p>It looks like nothing was found at this location.</p>
          </div>
        </div>
      </div>
    </section>
    <div>
      <article class="page-content">
        <div class="container narrow" data-aos="fade-in">
          <p class="lead">Sorry, we could not find what you are looking for, try one of the links below.</p>
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link to="/home" class="nav-link" title="Link: Home">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/products" class="nav-link" title="Link: Products">Products</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/producers" class="nav-link" title="Link: Producers">Producers</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link" title="Link: About us">About us</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/contact" class="nav-link" title="Link: Contact">Contact</router-link>
            </li>
            <li class="nav-item ">
              <router-link to="/favourites" class="nav-link" title="Link: Favourites">Favourites</router-link>
            </li>
            <li class="nav-item">
              <router-link ref="link" :to="{ name: 'terms'}" class="nav-link" title="Link: Products">
                Terms &amp; Conditions
              </router-link>
            </li>
            <li class="nav-item">
              <router-link ref="link" :to="{ name: 'privacy'}" class="nav-link" title="Link: Products">
                Privacy Policy
              </router-link>
            </li>
          </ul>
        </div>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
  import SiteFooter from '@/components/SiteFooter'
  import Navigation from '@/components/Navigation'

  export default {
    name: 'NotFoundPage',
    components: {
      SiteFooter,
      Navigation
    }
  };
</script>
